import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import cx from 'classnames';
import useToggle from 'react-use/lib/useToggle';
import { Card, Carousel } from 'react-bootstrap';
import styles from './ThumbnailCardUI.module.scss';
import stackedCards from '../assets/images/stackedCards.png';

import {
  ACTION_DOTS_ICON,
  DOWNLOAD_ICON,
  FAVOURITE_ICON,
  NOT_FAVOURITE_ICON,
  USER_PROFILE_PLACEHOLDER,
  ACTION_DOTS_HORIZONTAL_ICON,
} from '../constants/assetConstants';
import CircularProgress from '../components/CircularProgress/CircularProgress';
import Image from './Image';
import { Link } from 'react-router-dom';
import ReactTimeAgo from 'react-time-ago';
import { MOVE_TO_TEXTURE_ICON } from '../constants/assetConstants';
import { EditIcon } from '../components/icons/EditIcon';
import ShareIcon from '../components/icons/ShareIcon';
import CollectionIcon from '../components/icons/CollectionIcon';
import BinIcon2 from '../components/icons/BinIcon2';
import { isEmpty, merge, startCase, toLower } from 'lodash';
import { icons } from '../assets';
import { getSharingUserDetailsList } from '../helpers/api';
import { MODE, useApiList } from '../hooks/useApiList';
import { useUserContext } from '../contexts/UserContext';
import { useDispatch, useSelector } from 'react-redux';
import { filterSelector } from '../redux/slicers/filters/filterSlicer';
import InfiniteScroll from '../components/InfiniteScroll/InfiniteScroll';
import { ElipsisTooltip } from './ElipsisTooltip';
import { RiImageLine } from 'react-icons/ri';
import { RENDER_STATUS } from '../constants/constants';
import { selectGamificationTooltipData } from '../redux/slicers/gamificationTooltipSlicer';
import { isUserOnboarding, setTooltipData } from '../components/gamificationTooltip/helpers';
import { DropdownMenuItem } from '../common/DropdownMenuItem/DropdownMenuItem';
import { ContextMenu } from './ContextMenu/ContextMenu';
const { InfoIcon, DownloadIcon, MoveToTextureIcon, HeartIcon, HeartLineIcon, SharedUsersIcon } =
  icons;

export const ACTION = {
  RETRY: 'RETRY',
  RAISE_TICKET: 'RAISE_TICKET',
  UNDER_REVIEW: 'UNDER_REVIEW',
  RESTORE: 'RESTORE',
  DOWNLOAD: 'DOWNLOAD',
  EDIT: 'EDIT',
  MOVE_TO_TEXTURE: 'MOVE_TO_TEXTURE',
  SHARE: 'SHARE',
  ADD_TO_COLLECTION: 'ADD_TO_COLLECTION',
  DELETE: 'DELETE',
  DOWNLOAD_3D_FILES: 'DOWNLOAD_3D_FILES',
  COLLECT_3D_FILES: 'COLLECT_3D_FILES',
  START_ONBOARDING: 'START_ONBOARDING',
  START_OVER_ONBOARDING: 'START_OVER_ONBOARDING',
  CONTINUE: 'CONTINUE',
  TAKE_IT_AGAIN: 'TAKE_IT_AGAIN',
  EDIT_AI: 'Edit_with_magic_tool',
  COPY: 'COPY',
  PASTE: 'PASTE',
  UPDATE_JSON_DATA: 'UPDATE_JSON_DATA'
};

const ThumbnailCardUI = ({
  id,
  name,
  date,
  customDateTime = '',
  isFavourite,
  hideFavourite,
  favouriteLoading,
  thumbnail,
  images,
  selected,
  fullWidth,
  secondLine,
  onAddToCollection,
  imageText,
  showActionsText,
  actionsListClassName = '',
  customActions = {}, // { [ACTION.TEST]: {}}
  additionalData,
  originalData, // for collections/shared files it's represent collection or shared file
  data,
  capitalize = false,
  highlight,
  topText,
  bottomRightText,
  imageProps,
  tagList,
  tagListStyle = {},
  tagListItemStyle = {},
  showThumbnailInProgressText = null,
  blurCard = null,
  dateLabel = null,

  as,
  className = '',

  onDownload,
  downloadLoading,
  onEdit,
  onEditInfo,
  onEditAI,
  onMoveToTextures,
  onShare,
  onDelete,
  onSelect,
  onFavouriteChange,
  onCardImageClick,
  imageFit,

  onLinkClick,
  to,
  titleProps,
  target,
  size,
  modelType,

  isSharedItem,
  rotation = 0,
  children,
  curatorProp,
  overlayText,

  brandTag,
  brandNameSize,
  tooltipTargetProductId,
  tooltipTargetTextureId,
  tooltipTargetMaterialId,
  contextMenu,
  rightContextMenuItems,
  templateFilter,
  setCurrentMenu,
  currentMenuId,
  colorCode,
  ...rest
}) => {
  const ref = useRef(null);
  const moreUIRef = useRef(null);
  const [actionsOpen, toggleActionsOpen] = useToggle(false);
  const [hovered, setHovered] = useState(false);
  const [userListOpen, toggleUserListOpen] = useToggle(false);
  const gamificationTooltipData = useSelector(selectGamificationTooltipData);
  const { step } = gamificationTooltipData;
  const [openContextMenu, setOpenContextMenu] = useState(false);
  const { isGuestLogin } = useUserContext();
  const closeActionsOnOutsideClick = useCallback(
    (event) => {
      if (!ref.current || !ref.current.contains(event.target)) {
        toggleActionsOpen(false);
        toggleUserListOpen(false);
      }
    },
    [toggleActionsOpen, toggleUserListOpen]
  );
  useEffect(() => {
    if (!actionsOpen && !userListOpen) return;
    document.addEventListener('mousedown', closeActionsOnOutsideClick);
    return () => document.removeEventListener('mousedown', closeActionsOnOutsideClick);
  }, [actionsOpen, userListOpen]);

  const preventPropagation = (e) => {
    e.stopPropagation();
  };

  const hasActions = Boolean(
    onDownload ||
      onEdit ||
      onEditInfo ||
      onShare ||
      onAddToCollection ||
      onDelete ||
      onMoveToTextures ||
      Object.keys(customActions).length ||
      contextMenu?.items?.length
  );

  // actions
  const defaultActions = {
    [ACTION.DOWNLOAD]: {
      label: 'Download',
      loading: downloadLoading,
      onClick: onDownload,
      icon: <DownloadIcon />,
    },
    [ACTION.EDIT]: {
      label: 'Edit',
      onClick: onEdit,
      icon: <EditIcon />,
    },
    [ACTION.INFO]: {
      label: 'Edit Info',
      onClick: onEditInfo,
      icon: <InfoIcon />,
    },
    [ACTION.MOVE_TO_TEXTURE]: {
      label: 'Move to Texture',
      onClick: onMoveToTextures,
      icon: <MoveToTextureIcon />,
    },
    [ACTION.SHARE]: {
      label: 'Share',
      onClick: onShare,
      icon: <ShareIcon />,
    },
    [ACTION.ADD_TO_COLLECTION]: {
      label: 'Add to Collection',
      onClick: onAddToCollection,
      icon: <CollectionIcon />,
    },
    [ACTION.DELETE]: {
      label: 'Delete',
      onClick: onDelete,
      icon: <BinIcon2 />,
    },
    // [ACTION.EDIT_AI]: {
    //   label: 'Edit with magic tool',
    //   onClick: onEditAI,
    //   icon: <EditIcon />,
    // },
  };

  // TODO: handle case with no image
  const thumbnailSrc =
    thumbnail ||
    images?.[0]?.thumbnail ||
    data?.thumbnail ||
    data?.thumb ||
    data?.images?.[0]?.thumbnail ||
    '';
  let Component = as;
  const imageClickable = to || onLinkClick || onCardImageClick;
  if (!Component) {
    Component = to ? Link : 'div';
  }

  to = to ? to.replace(':id', id) : undefined;
  const dateToShow = additionalData?.date || date;
  const combinedTitleProps = titleProps || { to, as: to ? Link : undefined, target };
  const TitleComponent = combinedTitleProps?.as || 'h2';
  const titleClickable = Boolean(titleProps?.to || titleProps?.onClick);

  const actions = useMemo(() => {
    if (!actionsOpen || isGuestLogin) return {};
    return merge({}, defaultActions, customActions);
  }, [actionsOpen, downloadLoading]);

  const haveAngles = images?.every((a) => a?.thumbnail !== null);

  const handleHover = (hovered) => {
    setHovered(hovered);

    if (userListOpen) return;
    toggleActionsOpen(hovered);
  };

  const handleActionsToggle = (e) => {
    setCurrentMenu(id);
    setOpenContextMenu(!openContextMenu);
    e.stopPropagation();
  };

  const getTemplateHoverUI = (str) => {
    if (templateFilter === '1') {
      return (
        <div className={styles.cardAction} onClick={handleActionsToggle} ref={moreUIRef}>
          <DropdownMenuItem items={contextMenu.items} data={data} parentClass={true} />
        </div>
      );
    }
  };

  const getConfiguratorHoverUI = () => {
    return (
      <ul
        className={cx(
          'action-list ced-action',
          styles.actionsList,
          showActionsText && styles.withText,
          actionsListClassName
        )}>
        {Object.keys(actions).map((actionName) => {
          const config = actions[actionName];
          if (!config.onClick) return null;
          const { onClick, loading, label, icon } = config;
          return (
            <li key={actionName}>
              <div className="cardAC" onClick={() => onClick(id, data, originalData)} title={label}>
                {loading ? <CircularProgress size={14} thickness={1} /> : icon}
                <span className={styles.actionItemText}>{label}</span>
              </div>
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <Card
      ref={(r) => {
        if (
          r &&
          isUserOnboarding() &&
          ((step === 'SELECT_PRODUCT' && tooltipTargetProductId === id) ||
            (step === 'ADD_FINISH' && tooltipTargetTextureId === id) ||
            (step === 'ADD_WALL_FINISH' && tooltipTargetMaterialId === id))
        ) {
          setTooltipData({
            target:
              step === 'SELECT_PRODUCT'
                ? document.getElementById('CuratorSidebarLayoutScrollableContainer_products')
                : document.getElementById('CuratorSidebarLayoutScrollableContainer_style'),
          });
        }
        ref.current = r;
      }}
      className={cx(
        'thumbnail-card mb-0',
        fullWidth && styles.fullWidth,
        className,
        size === 'small' && styles.smallSize,
        topText && 'mt-4 overflow-visible'
      )}
      id={`thumbnail-card-${id}`}
      data-thumbnail-card
      {...rest}
      onMouseEnter={() => handleHover(true)}
      onMouseLeave={() => handleHover(false)}>
      {showThumbnailInProgressText && (
        <div className={styles.showThumbnailInProgressContainer}>
          <span className={styles.showThumbnailInProgressText}>{showThumbnailInProgressText}</span>
        </div>
      )}
      {topText && (
        <span
          style={{
            position: 'absolute',
            top: '-24px',
            left: 0,
            fontSize: 16,
            lineHeight: '21px',
            color: 'var(--black-color)',
          }}>
          {topText}
        </span>
      )}
      {children}
      <Component
        to={to}
        onClick={(e) => onLinkClick && onLinkClick(id, e)}
        target={target}
        className={cx(imageClickable && styles.clickable)}>
        <div className="thumbnail-img" onClick={onCardImageClick}>
          <div
            className={cx(
              'thumbnail-action',
              selected && 'thumbnail-action--selected',
              isFavourite && 'thumbnail-action--favourite',
              styles.thumbnailActionBar
            )}>
            {tagList?.length > 0 && (
              <div className={styles.tagList} style={tagListStyle}>
                {tagList.map((tag, idx) => {
                  const tagClassName = cx({
                    [styles.tagSuccess]: tag.type === 'success',
                    [styles.tagError]: tag.type === 'error',
                    [styles.tagPending]: tag.type === 'pending',
                    [styles.tagDisabled]: tag.type === 'disabled',
                    [styles.tagSecondary]: tag.type === 'secondary',
                  });

                  return (
                    <div key={idx} className={cx(tagClassName, styles.tag)} style={tagListItemStyle}>
                      {tag.label}
                    </div>
                  );
                })}
              </div>
            )}
            <ul className="action-list">
              <li className="thumbnail-action-checkbox">
                {onSelect && !rest.isTemplateCard && (
                  <>
                    <div className="form-check custom-checkbox">
                      <input
                        style={{ visibility: 'visible' }}
                        className="form-check-input m-0"
                        type="checkbox"
                        checked={selected}
                        onChange={() => onSelect(id, data, originalData)}
                      />
                      <label
                        onClick={(e) => {
                          e.preventDefault();
                          preventPropagation(e);
                          onSelect(id, data, originalData);
                        }}></label>
                    </div>
                  </>
                )}
              </li>
              {onFavouriteChange && !hideFavourite && !isUserOnboarding() && (
                <li
                  className={cx(
                    'thumbnail-action-favourite',
                    favouriteLoading && styles.favouriteLoading
                  )}>
                  <input
                    type="checkbox"
                    name="favouriteCard"
                    id={`favouriteCard-${id}`}
                    className="favouriteCard"
                    onChange={onFavouriteChange}
                    checked={isFavourite}
                    onClick={preventPropagation}
                  />
                  <label htmlFor={`favouriteCard-${id}`} onClick={preventPropagation}>
                    {!favouriteLoading && (isFavourite ? <HeartIcon /> : <HeartLineIcon />)}
                    {favouriteLoading && <CircularProgress size={14} thickness={1} />}
                  </label>
                </li>
              )}
            </ul>
          </div>
          <span className={blurCard}>
            {images?.length > 1 && haveAngles ? (
              <ImagesCarousel images={images} hovered={hovered} />
            ) : (
              <>
                <Image
                  src={thumbnailSrc}
                  placeholderWhileLoading
                  imgStyle={colorCode ? { display: 'none' } : ''}
                  placeholderColor={colorCode}
                  hideWithNoSrc
                  ratio={1.259}
                  style={
                    Number(rotation)
                      ? {
                          objectFit: imageFit || 'cover',
                          transform: `rotate(${Number(rotation)}deg)`,
                        }
                      : { objectFit: imageFit || 'cover' }
                  }
                  {...imageProps}
                />
                {imageText && (
                  <div className="itemCount" style={{ pointerEvents: 'none' }}>
                    {imageText}
                  </div>
                )}
              </>
            )}
          </span>

          {brandTag && (
            <div className={cx(styles.brandTag, brandNameSize === 'sm' && styles.smallBrandTag)}>
              {brandTag}
            </div>
          )}

          {overlayText && overlayText?.value && (
            <div
              className={cx(
                'overlayText',
                overlayText?.value === RENDER_STATUS.STATUS_PROCESSING && 'queue',
                overlayText?.value === RENDER_STATUS.STATUS_FAILED && 'failed'
              )}>
              {overlayText?.label}
            </div>
          )}

          {userListOpen && (
            <div className="main-item-toggel">
              <SharedUsersList id={originalData?.id} />
            </div>
          )}
        </div>
        {hasActions && (
          <div className="inner-action product-card">
            {actionsOpen && rest.isProductCard && <>{getTemplateHoverUI('product')}</>}
          </div>
        )}
      </Component>

      <Card.Body
        className={cx('thumbnail-info', styles.cardBody, {
          [styles.selected]: selected || highlight === 'info',
          [styles.success]: highlight === 'success',
          [styles.error]: highlight === 'error',
        })}>
        <Card.Title className="inner-info">
          <ElipsisTooltip title={name}>
            {({ ref, onMouseEnter, onMouseLeave }) => (
              <TitleComponent
                {...combinedTitleProps}
                as={undefined}
                ref={ref}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                className={cx('thumbnail-title', titleClickable && styles.clickable)}>
                {capitalize ? startCase(toLower(name)) : name}
              </TitleComponent>
            )}
          </ElipsisTooltip>

          <div className="d-flex gap-1 align-items-center">
            {isSharedItem && (
              <SharedUsersIcon
                onClick={() => {
                  toggleActionsOpen(false);
                  toggleUserListOpen(true);
                }}
              />
            )}
            {!isSharedItem && (
              <MemberThumbnail
                user={
                  data?.member_details ||
                  data?.owner_detail?.user ||
                  originalData?.created_by_details?.user
                }
              />
            )}
            {isSharedItem ? (
              <>
                {originalData?.latest_updated_at ? (
                  <h5 className="thumbnail-etime">
                    {<ReactTimeAgo date={Date.parse(originalData?.latest_updated_at)} />}
                  </h5>
                ) : null}
              </>
            ) : (
              <>
                {(dateToShow || customDateTime) && (
                  <h5 className="thumbnail-etime">
                    {customDateTime ? (
                      customDateTime
                    ) : (
                      <ReactTimeAgo date={Date.parse(dateToShow)} />
                    )}
                  </h5>
                )}
              </>
            )}
            {/* {(dateToShow || customDateTime) && (
          <h5 className="thumbnail-etime">
            {customDateTime ? customDateTime : <ReactTimeAgo date={Date.parse(dateToShow)} />}
          </h5>
        )} */}
            {secondLine && !dateLabel && (
              <ElipsisTooltip title={secondLine}>
                {(props) => (
                  <div
                    className={styles.secondLine}
                    style={isSharedItem ? { marginLeft: 'auto' } : {}}
                    {...props}>
                    {secondLine}
                  </div>
                )}
              </ElipsisTooltip>
            )}
            {bottomRightText && <span className={styles.stepData}>{bottomRightText}</span>}
            {dateLabel && <span className={styles.stepData}>{dateLabel}</span>}
          </div>
        </Card.Title>
        {hasActions && (
          <div className="inner-action">
            {actionsOpen && !rest.isProductCard && (
              <>{rest.isTemplateCard ? getTemplateHoverUI() : getConfiguratorHoverUI()}</>
            )}
          </div>
        )}
      </Card.Body>
      {rightContextMenuItems && (
        <ContextMenu element={ref.current} version="2" items={rightContextMenuItems.items} />
      )}
    </Card>
  );
};

const ImagePlaceholder = () => (
  <div className="w-100 h-100 d-flex justify-content-center align-items-center">
    <RiImageLine fontSize={24} className={'placeholderIcon'} />
  </div>
);

const ImagesCarousel = memo(({ images, hovered }) => {
  return (
    <Carousel className="cardCarouselContainer" indicators={false} interval={null}>
      {images.map((s, i) => (
        <Carousel.Item key={i}>
          {s?.thumbnail ? (
            <img src={s?.thumbnail} alt={s?.angle_name} loading={hovered ? 'eager' : 'lazy'} />
          ) : (
            <ImagePlaceholder />
          )}
        </Carousel.Item>
      ))}
    </Carousel>
  );
});

const SharedUsersList = memo(({ id }) => {
  const {
    currentUser: { organization },
  } = useUserContext();
  const {
    getSharedFilesQueryFilters: { shared_to, shared_to_org, shared_by },
  } = useSelector(filterSelector);

  const sharedUsersList = useApiList({
    api: getSharingUserDetailsList,
    mode: MODE.PARAMS,
    defaultPerPage: 5,
    params: {
      shared_model_id: id,
      shared_to: shared_to,
      shared_to_org: shared_to_org,
      shared_by: shared_by,
    },
  });

  const [loading, setLoading] = useState(sharedUsersList.loading || true);
  const dataList = sharedUsersList.list.map((a) => {
    if (shared_to) {
      return {
        id: a?.id,
        name: a?.shared_by_detail?.user?.name,
        thumbnail: a?.shared_by_detail?.user?.profile_image,
        organization_id: a?.shared_by_detail?.organization,
        organization_name: a?.shared_by_detail?.organization_detail?.name,
        date: a?.created_at,
      };
    }
    if (shared_to_org) {
      return {
        id: a?.id,
        name: a?.shared_by_detail?.user?.name,
        thumbnail: a?.shared_by_detail?.user?.profile_image,
        organization_id: a?.shared_by_detail?.organization,
        organization_name: a?.shared_by_detail?.organization_detail?.name,
        date: a?.created_at,
      };
    }
    if (shared_by) {
      return {
        id: a?.id,
        name: a?.shared_to_detail?.user?.name,
        thumbnail: a?.shared_to_detail?.user?.profile_image,
        organization_id: a?.shared_to_detail?.organization,
        organization_name: a?.shared_to_detail?.organization_detail?.name,
        date: a?.created_at,
      };
    }

    return {
      id: a?.id,
      name: a?.shared_by_detail?.user?.name,
      thumbnail: a?.shared_by_detail?.user?.profile_image,
      organization_id: a?.shared_by_detail?.organization,
      organization_name: a?.shared_by_detail?.organization_detail?.name,
      date: a?.created_at,
    };
  });

  useEffect(() => {
    setLoading(sharedUsersList.loading);
  }, [sharedUsersList]);

  if (loading) {
    return (
      <div style={{ height: '40px' }} className="d-flex align-items-center justify-content-center">
        <CircularProgress size={14} thickness={1} />
      </div>
    );
  }

  if (!dataList.length) return null;

  return (
    <InfiniteScroll
      dataLength={sharedUsersList.total}
      next={sharedUsersList.fetchNextPage}
      hasMore={sharedUsersList.hasMore}
      loading={sharedUsersList.loading}
      // hasChildren={hasData}
      scrollableTarget="infiniteScroll">
      {dataList.map(({ id, name, thumbnail, organization_id, organization_name, date }) => (
        <div className="inner-item-part" key={id}>
          <div className="item-image-text">
            <img src={thumbnail || USER_PROFILE_PLACEHOLDER} loading="lazy" />
            <div className="user-info">
              <h5>
                <span className="name">{name}</span>
                {date && Date.parse(date) ? (
                  <span className="time">
                    <ReactTimeAgo date={Date.parse(date)} />
                  </span>
                ) : null}
              </h5>
              {organization !== organization_id && (
                <h6>
                  <span>{organization_name}</span>
                </h6>
              )}
            </div>
          </div>
        </div>
      ))}
    </InfiniteScroll>
  );
});

export const MemberThumbnail = ({ user }) => {
  if (!user || user === undefined || !Object.keys(user).length) return null;

  const { profile_image, first_name, last_name, email, name } = user;

  const username = first_name && last_name ? `${first_name} ${last_name}` : name ? name : email;
  const initial =
    first_name && last_name
      ? `${first_name.slice(0, 1)}${last_name.slice(0, 1)}`
      : name
      ? name.slice(0, 1)
      : email ? email.slice(0, 1): '';

  return (
    <ElipsisTooltip title={username} alwaysShow={true}>
      {(props) => (
        <div className="custom-imges d-flex" {...props}>
          <span className="avatar">
            {profile_image ? (
              <img src={profile_image || USER_PROFILE_PLACEHOLDER} loading="lazy" />
            ) : (
              <span className="initial">{initial}</span>
            )}
          </span>
        </div>
      )}
    </ElipsisTooltip>
  );
};

export default ThumbnailCardUI;
